module.exports = __webpack_public_path__ + "img/adModel4.f3433d48.png";